import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-negative-formats-sel',
  templateUrl: './negative-formats-sel.component.html',
  styleUrls: ['./negative-formats-sel.component.scss']
})
export class NegativeFormatsSelComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
